function toggleNewUserModal(state, value) {
	state.showNewUserModal = value;
}

function setUserData(state, { id, key, value }) {

	let newUsers = state.users.slice();

	let user = newUsers.find( (x) => x.id === id);

	user[key] = value;

	state.users = newUsers;
}

function setNewUserData(state, { key, value }) {
	state.newUserData[key] = value;
}

function resetNew(state) {
	state.newUserData = {
		name: '',
		email: '',
		super: false,
		r10Id: null,
	};
}

function set(state, fn) {
	if (fn) {
		fn(state);
	}
}


export default {
	toggleNewUserModal,
	setUserData,
	setNewUserData,
	resetNew,
	set,
};